import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PageHeader } from 'components/header';
import PageTemplate from 'PageTemplates/PageTemplate';
import FlexRow from 'PageTemplates/FlexRowTemplate';
import { Tabs, Tab, Button } from 'react-bootstrap';
import OrdersList from 'components/ordersList/static';
import axios from 'axios';
import { setSpinner } from 'services/store/actions/view';
import { useModal } from 'hooks/useModal';
import { useAlert } from 'react-alert';
import PickOrdersToCuttingPackageModal from './components/PickOrdersToPackageModal';
import CuttingPackagesList from 'components/cuttingPackagesList/CuttingPackagesList';
import CustomDateRangePicker from 'components/DatePicker/CustomDateRangePicker';
import dayjs from 'dayjs';

const CuttingAdminPanel = () => {
  const dispatch = useDispatch();
  const alert = useAlert();
  const { modal, showModal, closeModal } = useModal({ newPackage: false });
  const [key, setKey] = useState('to-cut');
  const [dateFrom, setDateFrom] = useState(
    dayjs().subtract(1, 'month').startOf('day').toDate(),
  );
  const [dateTo, setDateTo] = useState(dayjs().endOf('day').toDate());

  const [ordersToCut, setOrdersToCut] = useState([]);
  // const [ordersInCutting, setOrdersInCutting] = useState([])
  const [cuttingPackagesInProgress, setCuttingPackagesInProgress] =
    useState([]);
  const [finishedCuttingPackages, setFinishedCuttingPackages] = useState(
    [],
  );

  const getCuttingOrders = useCallback(() => {
    dispatch(setSpinner(true));
    axios
      .get(`/api/orders`, {
        params: {
          status: 'piła',
        },
      })
      .then((res) => {
        const toCut = res.data.orders.filter(
          (order) => !order.cuttingPackage,
        );
        // const inProgress = res.data.orders.filter(
        //   (order) => order.cuttingPackage,
        // );
        setOrdersToCut(toCut);
        dispatch(setSpinner(false));
      });
  }, []);

  const getCuttingPackages = useCallback(() => {
    dispatch(setSpinner(true));
    axios
      .get(`/api/cutting`, {
        params: {
          status: 'oczekuje, w trakcie, nie kompletne',
        },
      })
      .then((res) => {
        setCuttingPackagesInProgress(res.data.cuttingPackages);
        dispatch(setSpinner(false));
      })
      .catch((err) => {
        console.log(err);
        alert.error('Błąd');
      });
  }, []);
  const getFinishedCuttingPackages = useCallback(() => {
    dispatch(setSpinner(true));
    axios
      .get(`/api/cutting`, {
        params: {
          status: 'gotowy',
          dateFrom: dayjs(dateFrom).startOf('day').toDate(),
          dateTo: dayjs(dateTo).endOf('day').toDate(),
        },
      })
      .then((res) => {
        setFinishedCuttingPackages(res.data.cuttingPackages);
        dispatch(setSpinner(false));
      });
  }, [dateFrom, dateTo]);

  useEffect(() => {
    if (key === 'to-cut') getCuttingOrders();
    else if (key === 'in-progress') getCuttingPackages();
  }, [key]);

  useEffect(() => {
    if (key === 'finished' && dateFrom && dateTo) {
      getFinishedCuttingPackages();
    }
  }, [key, dateTo]);

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setDateFrom(start);
    setDateTo(end);
  };

  return (
    <PageTemplate>
      <PageHeader
        title="Piła"
        extra={[
          <Button key={1} onClick={() => showModal('newPackage')}>
            Utwórz pakiet
          </Button>,
        ]}
        buttonFormat={false}
      />
      {key === 'finished' && (
        <FlexRow justify="end">
          <CustomDateRangePicker
            selectsRange={true}
            startDate={dateFrom}
            endDate={dateTo}
            onChange={handleDateChange}
            dateFormat="dd.MM.yyyy"
            locale="pl"
          />
        </FlexRow>
      )}
      <Tabs id="controlled-tab-example" activeKey={key} onSelect={setKey}>
        <Tab eventKey="to-cut" title="Do wycięcia">
          <OrdersList orders={ordersToCut} listName="new" status />
        </Tab>
        <Tab eventKey="in-progress" title="Aktywne pakiety cięcia">
          <CuttingPackagesList packages={cuttingPackagesInProgress} />
        </Tab>
        <Tab eventKey="finished" title="Zakończone">
          <CuttingPackagesList packages={finishedCuttingPackages} />
        </Tab>
      </Tabs>

      {/* MODALS */}
      {modal.newPackage && (
        <PickOrdersToCuttingPackageModal
          closeModal={closeModal}
          orders={ordersToCut}
        />
      )}
    </PageTemplate>
  );
};

export default CuttingAdminPanel;
